import dates from '../../../services/api/calculators/dates';
import monetary from '../../../services/api/calculators/monetary';
import {validDate} from 'components/form/validator/validations';
import Moment from 'moment';
import _ from 'lodash';

const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET'
};

// Initial State
const state = {
    dateOfBirth: null,
    gender: null,
    isRetired: false,
    dateFrom: null,
    dateTo: null,
    retirementDate: null,
    employmentType: 'employed',
    employmentIncome: 0,
    employmentIncomeNetGross: 'gross',
    totalGrossIncome: 0,
    totalNetIncome: 0,
};

// Getters
const getters = {
    findValue: state => key => state[key],
};

// Actions
const actions = {
    updateValue({state, commit, dispatch}, {key, value}) {
        commit(mutationTypes.UPDATE_VALUE, {key, value});
    },
    calculateEarnings: _.debounce(({ state, commit }) => {
        let incomeData = {
            employmentIncome: state.employmentIncome,
            employmentType: state.employmentType,
            endOfPeriod: state.dateTo,
            startOfPeriod: state.dateFrom,
            employmentNetGross: state.employmentIncomeNetGross,
            retired: state.isRetired,
            retirementDate: state.retirementDate
        };

        monetary.miniIncome(
            incomeData,
        ).then((data) => {
            commit(mutationTypes.UPDATE_VALUE, {key: 'totalNetIncome', value: data.totalNetIncome});
            commit(mutationTypes.UPDATE_VALUE, {key: 'totalGrossIncome', value: data.totalGrossIncome});
        });
    }, 500),
    updateRetirement: _.debounce(({state, commit, dispatch}) => {
        if (!validDate(state.dateOfBirth) || !state.gender) {
            return;
        }

        return dates.statePensionAge(state)
            .then((data) => {
                let dateFromM = Moment(state.dateFrom, 'DD/MM/YYYY');
                let retirementDateM = Moment(data.statePension.retirementDate, 'DD/MM/YYYY');

                commit(mutationTypes.UPDATE_VALUE, {key: 'isRetired', value: retirementDateM.isBefore(dateFromM)});
                commit(mutationTypes.UPDATE_VALUE, {key: 'retirementDate', value: data.statePension.retirementDate});
            });
    }, 500),
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.isRetired = false;
        state.dateFrom = null;
        state.dateOfBirth = null;
        state.dateTo = null;
        state.retirementDate = null;
        state.employmentType = 'employed';
        state.employmentIncome = 0;
        state.employmentIncomeNetGross = 'gross';
        state.totalGrossIncome = 0;
        state.totalNetIncome = 0;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/earnings.js